(function ($) {

    var debugAgenda = false;
    $(document).ready(function () {
        if ($("#day-name-cdr").length != 0) {

            function printCalendar() {
                console.log('printCalendar: ');
                moment.locale('fr');
                //var calendarId = '9sss908uf291vubp716jasptj8@group.calendar.google.com';
                var calendarId = 'chateaudurivau.com_706vb23a4l8fu17cj2tliqqk3k@group.calendar.google.com';
                var apiKey = 'AIzaSyDGpyMe3q5VjDt5hQ0SLEIJI7RoIeY9epM';
                var userTimeZone = "Europe/Paris";

                if (debugAgenda) {
                    var dateDuJour = '2020-10-18T08:00:00.000Z';
                    var dateDeFin = '2020-10-24T08:00:00.000Z';
                } else {
                    var dateJour = new Date();
                    var dateDuJour = (new Date()).toISOString();
                    var dateDeFin = new Date(dateJour.setMonth(dateJour.getMonth() + 2)).toISOString();
                }

                gapi.client.init({
                    'apiKey': apiKey,
                    'discoveryDocs': ['https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest'],
                }).then(function () {
                    return gapi.client.calendar.events.list({
                        'calendarId': calendarId,
                        'timeZone': userTimeZone,
                        'singleEvents': true,
                        'timeMin': dateDuJour,//(new Date()).toISOString(), //gathers only events not happened yet
                        'timeMax': dateDeFin,//(new Date()).toISOString(), //gathers only events not happened yet
                        //'maxResults': 20,
                        'orderBy': 'startTime'
                    });
                }).then(function (response) {
                    console.log('response : ', response);
                    console.log("event : ", response.result.items);
                    // $("#section-agenda-cdr-home").css({ "display": "block" });

                    if (response.result.items.length) {
                        $("#section-agenda-cdr-home").css({ "display": "block" });
                        var calendarRows = [];
                        var AllEventOnDate = [];
                        var jourNom = moment(response.result.items[0].start.dateTime).format('dddd');
                        var jourNumero = moment(response.result.items[0].start.dateTime).format('DD');
                        var mois = moment(response.result.items[0].start.dateTime).format('MMMM');
                        var nextEventDate = new Date(response.result.items[0].start.dateTime).getDate();
                        var nextEventMonth = new Date(response.result.items[0].start.dateTime).getMonth();
                        //var onlyOneEvent = true;
                        console.log('nextEventDate: ', nextEventDate);

                        response.result.items.forEach(function (entry) {
                            // console.log('nextEventMonth = new Date(entry.start.dateTime).getMonth(): ', nextEventMonth, new Date(entry.start.dateTime).getMonth());
                            // console.log('nextEventDate =  new Date(entry.start.dateTime).getDate()', nextEventDate, new Date(entry.start.dateTime).getDate())

                            if (nextEventDate === new Date(entry.start.dateTime).getDate() && nextEventMonth === new Date(entry.start.dateTime).getMonth()) {
                                //console.log('ok');
                                // nbrRequestSend++;
                                AllEventOnDate.push(entry)
                            }
                        });

                        AllEventOnDate.forEach(function (entry) {

                            var titreEvent = entry.summary;
                            var descEvent = entry.description;
                            var heureDebut = String(new Date(entry.start.dateTime).getHours());
                            var minuteDebut = String(new Date(entry.start.dateTime).getMinutes());

                            if (heureDebut.length === 1) {
                                heureDebut = "0" + heureDebut;
                            }
                            if (minuteDebut.length === 1) {
                                minuteDebut = "0" + minuteDebut;
                            }

                            var debutHeure = heureDebut + "h" + minuteDebut;

                            var heureFin = String(new Date(entry.end.dateTime).getHours());
                            var minuteFin = String(new Date(entry.end.dateTime).getMinutes());

                            if (heureFin.length === 1) {
                                heureFin = "0" + heureFin;
                            }
                            if (minuteFin.length === 1) {
                                minuteFin = "0" + minuteFin;
                            }
                            var finHeure = heureFin + "h" + minuteFin;

                            var heureEvent = debutHeure + " - " + finHeure;
                            var eventSummary = "";
                            var fileID = ""
                            var imgUrlEvent = "";

                            if (entry.attachments) {
                                if (entry.attachments.length > 0) {
                                    fileID = entry.attachments[0].fileId;
                                    imgUrlEvent = `https://drive.google.com/uc?id=${fileID}`;
                                }
                            }

                            eventSummary = `<div class="contenteventcdr"><div class="imgeventcdr" style="background-image: url(${imgUrlEvent})"></div><div class="textsumary"><div class="titreevent">${titreEvent}</div><div class="heureevent">${heureEvent}</div><div class="descevent"><span>${descEvent}</span></div></div></div>`;
                            calendarRows.push(eventSummary);

                        });
                        $("#day-name-cdr").html(jourNom);
                        $("#number-day-cdr").html(jourNumero);
                        $("#month-cdr").html(mois);

                        $("#summary-events-content-cdr").html(calendarRows.join(""));

                        $("#summary-events-content-cdr").niceScroll({
                            cursorcolor: "#00224f",
                            autohidemode: false,
                            cursorwidth: "8px",
                            cursorborder: "1px solid #F5F2EE",
                            cursorborderradius: "4px",
                        });

                    }
                }, function (reason) {
                    console.log("Error: " + reason.result.error.message);
                });
            };

            // Loads the JavaScript client library and invokes `start` afterwards.
            gapi.load("client", printCalendar);
        }
    });
})(jQuery);